<div class="col-lg-12 col-md-12  d-flex flex-column justify-content-center" style="padding: 5rem;">
  <div class="section-title mt-2">
    <h2>MUF-K.INTEGRATE</h2>
    <div class="bar"></div>
  </div>
  <div class="about-content">

    <p><strong>MUF-K.INTEGRATE</strong> is a robust, web-based incident management platform designed to streamline
        and oversee the complete claims lifecycle between insurance companies and their network of service providers.
        The system facilitates seamless communication and operational efficiency—from the moment a client initiates
        a claim to the final resolution by the assigned service provider.</p>

 <!--   <p>Claims can be logged into the HIMCO system through three primary channels:</p>
    <ul>
      <li>Direct phone call from a key client to a HIMCO representative</li>
      <li>Submission via email</li>
      <li>Direct entry by a HIMCO agent or an authorized client using the Incident Management System (IMS)</li>  
    </ul>-->

   </div><br><br><br><br>

    <div>
      
    <img src="assets/img/himco.png" alt="Davha Incubation" class="img-fluid rounded shadow-sm"
       style="height: max-content; width: 150vw; object-fit: cover;" >
  </div>